<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{margin:0;padding:0;font-family: 'Segoe UI',SegoeUI,'Microsoft YaHei',微软雅黑,"Helvetica Neue",Helvetica,Arial,sans-serif}
html, body, #app{width:100%;height:100%;color:#333}
html, body, h1, h2, h3, h4, h5, h6{font-weight:300}
h1, h2, h3, h4, h5, h6{padding:10px 0}
form{width:90%;margin:0 auto}

.wrapper{width:100%;height:100%}
.block{width:100%}
.focus-card{border-top:#4f5682 2px solid}
.wingspace{margin-left:10px!important;margin-right:10px!important}
.container{width:100%;height:100%;overflow-y:auto}
.uploader{width:100px;height:100px;text-align:center;line-height:100px;font-size:28px;border:#ddd 1px dashed;color:#409EFF;border-radius:10px;}
.uploader img{height:100px}
.uploader-xs{width:70px;height:70px;text-align:center;line-height:70px;font-size:28px;border:#ddd 1px dashed;color:#409EFF;border-radius:10px;}
.uploader-xs img{height:70px}
.filter{width:100%}
.cursor-pointer{cursor:pointer}

.size-s{font-size:12px;}
.size-m{font-size:24px;}
.size-l{font-size:36px;}

.text-center{text-align:center}
.text-left{text-align:left}
.text-right{text-align:right}

.pull-left{float:left}
.pull-right{float:right}

.flex-center{display:flex;justify-content:center}
.flex-align-center{align-items: center;}
.flex-right{display:flex;justify-content:flex-end}
.flex-start{display: flex;}
.flex-between{display: flex;justify-content: space-between;}
.flex-warp{flex-wrap: wrap;align-content: space-between;}

.strong{font-weight:bold}

.margin-0{margin:0}
.margin-5{margin:5px}
.margin-10{margin:10px}
.margin-tb-5{margin-top:5px!important;margin-bottom:5px!important}
.margin-tb-10{margin-top:10px!important;margin-bottom:10px!important}
.margin-tb-15{margin-top:15px!important;margin-bottom:15px!important}
.margin-tb-20{margin-top:20px!important;margin-bottom:20px!important}
.margin-tb-25{margin-top:25px!important;margin-bottom:25px!important}
.margin-tb-30{margin-top:30px!important;margin-bottom:30px!important}
.margin-t-10{margin-top:10px!important;}
.margin-b-10{margin-bottom:10px!important}
.margin-r-5{margin-right:10px}

.padding-0{padding:0}
.padding-2{padding:2px !important}
.padding-5{padding:5px}
.padding-8{padding:8px}
.padding-10{padding:10px}
.padding-20{padding:20px}
.padding-left-5{padding-left: 5px;}
.padding-left-20{padding-left:20px}
.padding-right-20{padding-right:20px}
.padding-top-10{padding-top:10px}
.padding-b-10{padding-bottom:10px}

.width-xl{width:100%!important}
.width-l{width:400px!important}
.width-m{width:300px!important}
.width-s{width:200px!important}
.width-xs{width:100px!important}
.width-xxs{width:50px!important}

.color-primary, .color-primary a{color:#4f5682}
.color-blue, .color-blue a{color:#409EFF}
.color-white, .color-white a{color:#fff}
.color-describe, .color-describe a{color:#a0b4c8}
.color-danger, .color-danger a{color:#F56C6C}
.color-success, .color-success a{color:#67C23A}
.color-warning, .color-warning a{color:#E6A23C}
.color-cancel, .color-cancel a{color:#c0c4cc}
.color-black{color:black}
.color-purple{color:#800080}
.color-purple:hover{color:#800000}
.color-violet{color:violet}
.color-rebeccapurple{color:rebeccapurple}
.bg-warning{background-color: #E6A23C;}
.bg-danger{background-color: #F56C6C;}
.border-danger{border: 2px solid #F56C6C;}
.border{border: 2px solid #333;}

.row-important {background: oldlace!important}
.row-important td{background: oldlace!important}
.row-error {color: red!important}
.row-unread {font-weight: bold}

.tip {padding: 8px 16px;background-color: #ecf8ff;border-radius: 4px;border-left: 5px solid #50bfff;margin: 20px 0;}

.thumb {height:100px;}
.thumb-block {width:100%}
.thumb-list {height:50px}
.thumb-detail {height:200px}
.thumbs {position:relative;padding-right:5px}
.thumbs .preview{position:absolute;top:5px;left:5px;line-height:0}
.thumbs .remove{position:absolute;top:5px;left:30px;line-height:0}
.tag-main{position: relative;}
.tag-close{position:absolute;top:5px;right:5px;}
.tag-left{position:absolute;top:5px;left:5px;}

/* element ui hack */
.el-menu{border:none}
.el-dropdown-link{cursor:pointer}
.el-tabs .el-tabs__nav-wrap{height:80%;top:20%}
.el-tabs .el-tabs__nav, .el-tabs .el-tabs__nav-scroll, .el-tabs .el-tabs__item{height:100%}
.el-tabs .el-tabs__header{padding-left:10px;margin:0}
.el-tabs .el-tabs__content{height:calc(100% - 84px)}
.el-tabs .el-tabs__item i{font-size:18px}
.el-tabs .el-tabs__item.is-active{background:#fff}
.el-dialog__body{padding:0}
.el-form-item{margin-bottom:22px}
.dialog .el-dialog{width:75%}
.dialog .el-dialog__header{padding:0;height:5%;}
.dialog .el-dialog__title{margin:15px;line-height:45px}
.dialog .el-dialog__headerbtn{top:15px;right:15px}
.dialog .el-dialog__body{height:94%;margin-top:1%}
.vertical-radios .el-radio {
  display: block;
  margin-bottom: 10px;
}
@keyframes example {
  0%   { opacity: 1; }
  50%  { opacity: 0.1; }
  100% { opacity: 1; }
}
.icon-gif {
  animation-name: example;
  animation-duration: 1s; /* 持续时间 */
  animation-iteration-count:infinite;
}
.el-table .warning-row {
  background: oldlace !important;
}
.el-table .success-row {
  background: #f0f9eb !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue